import { Icon } from '@components/index';

interface UploadStatusMessageProps {
  step: 'warning_preview' | 'error_preview' | string;
  membersWithErrors?: number;
}

const UploadStatusMessage = ({
  step,
  membersWithErrors = 0
}: UploadStatusMessageProps) => {
  if (step === 'warning_preview') {
    return (
      <div className="flex items-center gap-2">
        <Icon
          name="info-red"
          size="medium"
          className="text-cofeeWarningYellow"
        />
        <p className="text-cofeeWarningYellow text-sm">
          Proceeding will overwrite the existing records.
        </p>
      </div>
    );
  }

  if (step === 'error_preview' && membersWithErrors > 0) {
    return (
      <div className="flex items-center gap-2">
        <Icon name="info-red" size="medium" className="text-cofeeRed7" />
        <p className="text-sm text-cofeeRed7">
          The rows marked in red will not be added to the member list
        </p>
      </div>
    );
  }

  return <div />;
};

export default UploadStatusMessage;
